import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { SearchPrivate } from '@snack-uikit/search-private';
import { ITEM_PREFIXES } from '../../../constants';
import { useNewListContext } from '../../Lists/contexts';
import commonStyles from '../styles.module.css';
import styles from './styles.module.css';
export function SearchItem({ search, itemRef }) {
    const { size = 's', firstItemId } = useNewListContext();
    const handleKeyDown = (e) => {
        if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
            e.preventDefault();
        }
    };
    const handleFocus = (e) => {
        e.stopPropagation();
    };
    if (!search) {
        return null;
    }
    return (_jsx("div", { className: cn(commonStyles.listItem, styles.searchItem), "data-size": size, "data-test-id": 'list__search-item', children: _jsx(SearchPrivate, Object.assign({ size: size, tabIndex: ITEM_PREFIXES.search === firstItemId ? 0 : -1, onKeyDown: handleKeyDown, onFocus: handleFocus }, search, { ref: itemRef })) }));
}
